import React, { FunctionComponent } from 'react';

// MUI
import Box from '@mui/material/Box';

// Common
import { GENERAL } from '../../../../constants';

// Components
import { Modal } from '../../../Modal';

// Properties
import * as styles from './ModalCookies.styles';

type TProps = {
    open: boolean;
    onClose: () => void;
}

const ModalCookies: FunctionComponent<TProps> = ({
    open,
    onClose,
}) => {
    return (
        <Modal
            open={open}
            onClose={onClose}
            title={GENERAL.COOKIES_TITLE}
        >
            <Box sx={styles.list}>
                <ol type="1">
                    {GENERAL.COOKIES_INFO.map(
                        (text) =>
                            <li key={text.id}>
                                {text.paragraph}
                                {text.paragraphs
                                    ?
                                    <ol type="a">
                                        {text.paragraphs.map(subText =>
                                            <li key={subText.id}>
                                                {subText.paragraph}
                                            </li>
                                        )}
                                    </ol>
                                    : null}
                            </li>
                    )}
                </ol>
            </Box>
        </Modal>
    );
};

export default ModalCookies;
